import * as React from "react";
import { IconProps } from "ztypes/icon-props";

const IconClose: React.FunctionComponent<IconProps> = (props) => {
  return (
    <svg
      className={props.className}
      onClick={props.onClick}
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M1.09961 8.0001C1.09961 4.18933 4.18884 1.1001 7.99961 1.1001C11.8104 1.1001 14.8996 4.18933 14.8996 8.0001C14.8996 11.8109 11.8104 14.9001 7.99961 14.9001C4.18884 14.9001 1.09961 11.8109 1.09961 8.0001ZM5.27535 5.27583C5.50966 5.04152 5.88956 5.04152 6.12387 5.27583L7.99961 7.15157L9.87535 5.27583C10.1097 5.04152 10.4896 5.04152 10.7239 5.27583C10.9582 5.51015 10.9582 5.89005 10.7239 6.12436L8.84814 8.0001L10.7239 9.87583C10.9582 10.1101 10.9582 10.49 10.7239 10.7244C10.4896 10.9587 10.1097 10.9587 9.87535 10.7244L7.99961 8.84863L6.12387 10.7244C5.88956 10.9587 5.50966 10.9587 5.27535 10.7244C5.04103 10.49 5.04103 10.1101 5.27535 9.87583L7.15108 8.0001L5.27535 6.12436C5.04103 5.89005 5.04103 5.51015 5.27535 5.27583Z"
        fill="#212121"
        fillOpacity="0.5"
      />
    </svg>
  );
};

export default IconClose;
